import { get } from 'lodash'
import { adminBeneficiaryVettingList } from './admin_beneficiary_vetting'
import { adminBeneficiaryList } from '../../beneficiaries/actions/admin_beneficiary'
import { confirmModal } from '../../../../actions/ui'
import React from 'react'

export const REVET_QUERY_PARAM = 'revet'
export const REVET_QUERY_VALUE = '1'
export const FROM_REVETTING_STATE_KEY = 'fromRevetting'

export const PATH_BENEFICIARIES = '/admin/beneficiaries'
export const PATH_VETTING_PREFIX = '/admin/beneficiary_vetting'

export function getRevetVettingPath(beneficiaryId) {
  if (!beneficiaryId) return PATH_VETTING_PREFIX
  return `${PATH_VETTING_PREFIX}/${beneficiaryId}?${REVET_QUERY_PARAM}=${REVET_QUERY_VALUE}`
}

export function getVettingPath(beneficiaryId) {
  if (!beneficiaryId) return PATH_VETTING_PREFIX
  return `${PATH_VETTING_PREFIX}/${beneficiaryId}`
}

export function isRevettingFlowFromLocation(location) {
  if (!location) return false
  const params = new URLSearchParams(location.search || '')
  return (
    params.get(REVET_QUERY_PARAM) === REVET_QUERY_VALUE ||
    get(location, 'state.revet') === true
  )
}

export function isFromRevettingNavigation(location) {
  return get(location, `state.${FROM_REVETTING_STATE_KEY}`) === true
}

export async function navigateToRevetVetting(history, dispatch, beneficiaryId) {
  if (!history || !dispatch || !beneficiaryId) {
    return
  }

  try {
    await dispatch(adminBeneficiaryList['ensureObjectLoaded'](beneficiaryId))

    const beneficiary = adminBeneficiaryList['getObject'](beneficiaryId)
    const companyRef = get(beneficiary, 'company.id')

    if (!companyRef) {
      console.log('[revet] beneficiary has no company ref, exiting early')
      return
    }

    const listFilter = { company_ref: companyRef, status: 'vetting_in_progress' }

    // Always invalidate and force fetch so this works from any route, not just from cached history state.
    dispatch(adminBeneficiaryVettingList.invalidateList())
    dispatch(adminBeneficiaryVettingList.updateListFilter(listFilter))
    await dispatch(adminBeneficiaryVettingList.fetchListIfNeeded(true))

    const inProgressVettings = adminBeneficiaryVettingList.getVisibleObjects() || []

    if (inProgressVettings.length > 0) {
      dispatch(confirmModal({
        text: inProgressVettings.length > 1
        ? <>
            There are multiple vetting records in progress for this beneficiary.  You can view and open existing records from the Vetting History tab or the beneficiary vetting page.
            <br />
            Continue to create a new record?
          </>
        : <>
            There is already a vetting record in progress for this beneficiary. You can view and open the existing record from the Vetting History tab or the beneficiary vetting page.
            <br />
            Continue to create a new record?
          </>,
       onConfirmed: () => { history.push(getRevetVettingPath(beneficiaryId))},
        can_cancel: true,
      }))     
      listFilter.status = 'all'
      dispatch(adminBeneficiaryVettingList.updateListFilter(listFilter))
      await dispatch(adminBeneficiaryVettingList.fetchListIfNeeded(true))
      return
    }

    history.push(getRevetVettingPath(beneficiaryId))

  } catch (error) {
    console.log('Failed during navigateToRevetVetting')
  }
  finally {
    dispatch(adminBeneficiaryVettingList.clearListFilter())
  }

}
